/**
 * OwnerWsActions — WsActions implementation that wraps the real DenkerWebSocket.
 *
 * Lives in the owner webview only; constructed by the owner connection
 * (`desktop/use-owner-connection.ts`) and stored via `setCurrentDenkerWs`.
 * Mirrors never construct this.
 */

import type { DenkerWebSocket } from "@/api/websocket";
import type { WsActions, SendPromptArgs } from "@/api/ws-actions";

export class OwnerWsActions implements WsActions {
  private ws: DenkerWebSocket;

  constructor(ws: DenkerWebSocket) {
    this.ws = ws;
  }

  sendPrompt(args: SendPromptArgs): void {
    this.ws.sendPrompt(args);
  }

  stopExecution(executionId: string): void {
    this.ws.stopExecution(executionId);
  }

  resumeExecution(executionId: string): void {
    this.ws.resumeExecution(executionId);
  }

  subscribeProject(projectId: string): void {
    this.ws.subscribeProject(projectId);
  }

  unsubscribeProject(projectId: string): void {
    this.ws.unsubscribeProject(projectId);
  }

  sendGithubFrameViewBranch(
    projectId: string,
    frameId: string,
    branch: string,
  ): void {
    this.ws.sendGithubFrameViewBranch(projectId, frameId, branch);
  }

  manualReconnect(): void {
    this.ws.manualReconnect();
  }

  sendRaw(type: string, data: Record<string, unknown>): void {
    this.ws.send({ type, data });
  }
}
